import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MultiStepModalComponent } from '../../module/fna/components/multi-step-modal/multi-step-modal.component';

@Directive({
  selector: '[appScrollSpy]',
})
export class ScrollSpyDirective {
  @Input() componentRef: any;

  constructor(private _el: ElementRef, private host: MultiStepModalComponent) {
    // console.log('Host', host);
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const winScroll = event.currentTarget.scrollTop;
    const height =
      event.currentTarget.scrollHeight - event.currentTarget.clientHeight;
    const scrolled = (winScroll / height) * 100;

    this.host.scrollPercentage = scrolled;
    // console.log('Scrolled %: ', scrolled);
  }
}
